import { render, staticRenderFns } from "./layout_intinerary.vue?vue&type=template&id=12d495e5"
import script from "./layout_intinerary.vue?vue&type=script&lang=js"
export * from "./layout_intinerary.vue?vue&type=script&lang=js"
import style0 from "./layout_intinerary.vue?vue&type=style&index=0&id=12d495e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports